<template>
  <div>
    <div id="echart" :class="className" :style="{height:height,width:width}" />
  </div>

</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import { debounce } from '@/utils'
// import { aeoEnterpriseCode } from '@/lang/zh_CN/Partners'

export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      sidebarElm: null,
      dialogVisible: false
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
    }

    // 监听侧边栏的变化
    this.sidebarElm = document.getElementsByClassName('sidebar-container')[0]
    this.sidebarElm && this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }

    this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler)

    this.chart.dispose()
    this.chart = null
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.__resizeHandler()
      }
    },
    setOptions({ SE, SI, AE, AI, RE, xAxisData } = {}) {
      console.log(xAxisData)
      this.chart.setOption({
        xAxis: [{
          data: xAxisData,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#d1d1d1',
              width: 1
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#666666', // 这里用参数代替了
              fontSize: '12'
            }
          }
        }],
        grid: {
          left: 10,
          right: 20,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10],
          icon: 'square',
          label: {
            backgroundColor: 'rgba(222, 234, 249, 0.9)'
          },
          background: 'rgba(255, 255, 255, 0.9)'
        },
        yAxis: {
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#d1d1d1',
              width: 0
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333', // 这里用参数代替了
              fontSize: '14'
            }
          },
          minInterval: 1
        },
        legend: {
          data: ['SeaExport', 'SeaImport', 'AirExport', 'AirImport', 'RailwayExport'],
          bottom: '0%',
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 23
        },
        series: [{
          name: 'SeaExport', itemStyle: {
            normal: {
              color: '#42B983',
              lineStyle: {
                color: '#42B983',
                width: 2
              }
            }
          },
          smooth: true,
          type: 'line',
          data: SE,
          animationDuration: 2800,
          animationEasing: 'cubicInOut',
          symbol: 'circle',
          symbolSize: 12
        }, {
          name: 'SeaImport',
          smooth: true,
          type: 'line',
          symbol: 'circle',
          symbolSize: 12,
          itemStyle: {
            normal: {
              color: '#E6A23D',
              lineStyle: {
                color: '#E6A23D',
                width: 2
              }
            }
          },
          data: SI,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: 'AirExport',
          smooth: true,
          type: 'line',
          symbol: 'circle',
          symbolSize: 12,
          itemStyle: {
            normal: {
              color: '#F79494',
              lineStyle: {
                color: '#F79494',
                width: 2
              }
            }
          },
          data: AE,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: 'AirImport',
          smooth: true,
          type: 'line',
          symbol: 'circle',
          symbolSize: 12,
          itemStyle: {
            normal: {
              color: '#1F75D5',
              lineStyle: {
                color: '#1F75D5',
                width: 2
              }
            }
          },
          data: AI,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: 'RailwayExport',
          smooth: true,
          type: 'line',
          symbol: 'circle',
          symbolSize: 12,
          itemStyle: {
            normal: {
              color: '#8957A1',
              lineStyle: {
                color: '#8957A1',
                width: 2
              }
            }
          },
          data: RE,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }]
      })
    },
    initChart() {
      this.chart = echarts.init(document.getElementById('echart'), 'macarons')
      this.setOptions(this.chartData)
    },
    showWeeklyDialog() {
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss">
  .title .el-popper[x-placement^="bottom"] .popper__arrow::after {
  margin-left: -28px;
}
</style>
